import { useState } from "react";
import { ArrowClockwise } from "@phosphor-icons/react";
import { forceRefreshApp } from "@/lib/swUpdate";

// Manual fallback: force-check for a new deploy, else clear app caches and reload once.
// Never removes localStorage cart, login token, or IndexedDB data.
export default function PwaRefreshButton({ className = "", label = "Perbarui Aplikasi", testid = "pwa-refresh-button" }) {
  const [busy, setBusy] = useState(false);
  const onClick = () => {
    setBusy(true);
    forceRefreshApp();
  };
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      disabled={busy}
      className={className || "flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-[#6A38C7] transition-colors hover:bg-[#EEE6FF] disabled:opacity-60"}
    >
      <ArrowClockwise size={18} weight="bold" className={busy ? "animate-spin" : ""} /> {busy ? "Memperbarui…" : label}
    </button>
  );
}
